// Gamification stat — one aspect, one padding, mono tabular numeral. `value`
// can be a node (e.g. a mood face or flame icon). numColor tints the numeral
// (e.g. --streak). onInfo shows the little info dot.
export function StatCard({ value, label, numColor, onInfo, style }) {
  return (
    <div className="bz-stat" style={style}>
      {onInfo && (
        <button type="button" className="bz-stat__info" onClick={onInfo} aria-label="Info">i</button>
      )}
      <div className="bz-stat__num" style={numColor ? { color: numColor } : undefined}>{value}</div>
      <div className="bz-stat__label">{label}</div>
    </div>
  );
}
